export const addVenueIdIsMigrated = client => (venueId, objectType) => {
    return client.post(`/venues/migration/${venueId}/objectType/${objectType}`);
};

export const venueIdIsMigrated = client => venueId => {
    return client.get(`/venues/migration/${venueId}`);
};

export const listVenueIds = client => () => {
    return client.get(`/venues`);
};

export const describeVenue = client => venueId => {
    return client.get(`/venues/${venueId}`);
};

export const getBoundingBoxes =
    client =>
    (venueId, { coordinateFormat, boxFormat } = {}) => {
        return client.get(`/venues/${venueId}/boundingBoxes`, { params: { coordinateFormat, boxFormat } });
    };

export const getBoundsPolygons =
    client =>
    (venueId, { coordinateFormat } = {}) => {
        return client.get(`/venues/${venueId}/boundsPolygons`, { params: { coordinateFormat } });
    };

export const getEntities =
    client =>
    (venueId, { locale, format, accountId } = {}) => {
        return client.get(`/venues/${venueId}/entities`, { params: { locale, format, accountId } });
    };

export const getFeatures =
    client =>
    (venueId, { levelId, locale, format } = {}) => {
        return client.get(`/venues/${venueId}/features`, { params: { levelId, format, locale } });
    };

export const putEntities =
    client =>
    (venueId, entities, { accountId, locale, format } = {}) => {
        return client.put(`/venues/${venueId}/entities`, entities, { params: { accountId, format, locale } });
    };

export const putFeaturesAndEntities =
    client =>
    (venueId, featuresAndEntities, { format } = {}) => {
        return client.put(`/venues/${venueId}/features-and-entities`, featuresAndEntities, { params: { format } });
    };

export const putFeaturesFromIllustrator = client => (venueId, aiJsonBlobRequestBody) => {
    return client.put(`/venues/${venueId}/features-from-illustrator`, aiJsonBlobRequestBody);
};

export const tagMap = client => venueId => {
    return client.post(`/venues/${venueId}/tag`);
};

export const pushThemeToContent =
    client =>
    (vertical, theme, { accountId, venueId } = {}) => {
        return client.put(`/content/theme/vertical/${vertical}`, theme, { params: { accountId, venueId } });
    };

export const renderNavGraphForAiJson = client => (venueId, aiJson) => {
    return client.post(`/venues/${venueId}/navigation/renderNavGraphForAiJson`, aiJson);
};

export const validateMapData =
    client =>
    (venueId, aiJson, { validateForIMDF } = {}) => {
        return client.post(`/venues/${venueId}/validate-map-data`, aiJson, { params: { validateForIMDF } });
    };

export const getVenueConfiguration = client => (venueId, configurationType) => {
    return client.get(`/venues/${venueId}/configuration/${configurationType}`);
};

export const putVenueConfiguration = client => (venueId, configurationType, configuration) => {
    return client.put(`/venues/${venueId}/configuration/${configurationType}`, configuration);
};

export const getVenueConfigurationWithAccount = client => (venueId, accountId, configurationType) => {
    return client.get(`/venues/${venueId}/accounts/${accountId}/configuration/${configurationType}`);
};

export const putVenueConfigurationWithAccount = client => (venueId, accountId, configurationType, configuration) => {
    return client.put(`/venues/${venueId}/accounts/${accountId}/configuration/${configurationType}`, configuration);
};

export const putAccountWithCustomVenueData = client => (venueId, accountId) => {
    return client.put(`/venue-data-override-index/venues/${venueId}/accounts/${accountId}`);
};

export const listAccountsWithCustomVenueData = client => venueId => {
    return client.get(`/venue-data-override-index/venues/${venueId}`);
};

export const listAccountsWithCustomColors = client => venueId => {
    return client.get(`/venues/${venueId}/accountsWithCustomColors`);
};

export const putVenueDataObject =
    client =>
    (venueId, type, data, { accountId } = {}) => {
        if (accountId) {
            return client.put(`/venues/${venueId}/objectType/${type}/account/${accountId}`, data);
        } else return client.put(`/venues/${venueId}/objectType/${type}`, data);
    };

export const getVenueDataObject =
    client =>
    (venueId, type, { accountId, raw } = {}) => {
        if (accountId) {
            return client.get(`/venues/${venueId}/objectType/${type}/account/${accountId}`, { params: { raw } });
        } else return client.get(`/venues/${venueId}/objectType/${type}`, { params: { raw } });
    };

export const getAiJson = client => venueId => {
    return client.get(`/venues/${venueId}/features`);
};

export const rmsv1GetAiJson =
    client =>
    (venueId, { format } = {}) => {
        return client.get(`/v1/venues/${venueId}/features`, { params: { format } });
    };

export const putAiJson = client => (venueId, data) => {
    return client.put(`/venues/${venueId}/features`, data);
};

export const listVenuesForAccount =
    client =>
    (accountId, { locale } = {}) => {
        return client.get(`/v1/accounts/${accountId}/venues`, { params: { locale } });
    };
